<template>
  <div class="">
    <div class="container">
      <div class="card vov_schedule">
        <div class="card-body p-0">
          <div class="area_content">
            <div class="column-left">
              <div class="area_head"> Danh sách kênh </div>
              <div class="area_inner">
                <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                  <ul>
                    <li v-for="(item, index) in dataChannel" :key="index" :class="channel_id == item.id ? 'active' : ''"
                      @click="handleChannel(item)"><span>{{ item.name }}</span></li>
                  </ul>
                </b-overlay>
              </div>
            </div>
            <div class="column-right">
              <div class="area_inner">
                <div class="area_head">
                  <div class="datetime">
                    <div style="margin-right: 0.5rem;" class="d-md-none">
                      <b-form-select v-model="channel_id" style="width: 8rem;" :options="dataChannel"
                        @input="onChangeSelect" value-field="id" text-field="name" />
                    </div>
                    <date-picker v-model="dateplay" format="YYYY-MM-DD" type="date" placeholder="Select date" />
                  </div>
                  <div class="search">
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="SearchIcon" />
                      </b-input-group-prepend>
                      <b-form-input placeholder="Tìm kiếm" v-model="localSearchQuery" @keyup.enter="updateSearchQuery" />
                    </b-input-group>
                  </div>
                </div>
                <b-overlay :show="loading_schedule" spinner-variant="primary" spinner-type="grow" spinner-small
                  rounded="sm">
                  <b-table :items="dataItems" responsive :fields="tableColumns" primary-key="id" show-empty
                    empty-text="Không có lịch xem lại">
                    <template #head(programFrames)="data">
                      <div class="programe">
                        <span class="name">Tên chương trình</span>
                        <span class="duration">Thời lượng</span>
                        <span class="thaotac">Thao tác</span>
                      </div>
                    </template>
                    <template #cell(programFrames)="data">
                      <ul>
                        <li v-for="(item, index) in data.item.programFrames" :key="index"
                          :class="(itemPlay.urlPath == item.urlPath && item.titleId == titleId) ? 'active' : ''">
                          <div class="programe" :class="item.urlPath ? 'bold' : ''">
                            <span class="name" @click="onPlayItem(data.item.programFrames, item.titleId)">{{
                              item.programName }}</span>
                            <span class="duration"> {{ item.duration }}</span> <span class="thaotac"
                              @click="onDownload(item)">
                              <i class="download"></i>
                            </span>
                          </div>
                          <div class="programe2">
                            <div class="name" @click="onPlayItem(data.item.programFrames, data.item.titleId)">{{
                              item.programName }}</div>
                            <div class="info">
                              <span class="duration">Thời lượng: {{ item.duration }}</span>
                              <span class="thaotac" @click="onDownload(item)">
                                <i class="download"></i>
                              </span>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </template>
                  </b-table>
                  <div class="paginations" v-if="dataItems.length > 0">
                    <b-row>
                      <b-col cols="12" sm="12" class="d-flex align-items-center justify-content-center">
                        <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number
                          last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                          <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                          </template>
                          <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                          </template>
                        </b-pagination>
                      </b-col>
                    </b-row>
                  </div>
                </b-overlay>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="media_player" v-if="dataItems.length > 0">
      <div class="container">
        <div id="audio" class="player-wrapper">
          <audio-player :itemPlay="itemPlay" :titleId="titleId" :playlist="playlist" :stopPlay="stopPlay"
            :channel_name="channel_name" @updateAudio="handUpdateItemAudio" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import { ref, watch, computed } from '@vue/composition-api'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import AudioPlayer from '@/libs/AudioPlayer.vue';
import {
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BButton,
  BOverlay,
  BTable,
  BCard,
  BRow,
  BCol,
  BPagination,
  BFormSelect

} from 'bootstrap-vue';

export default {
  components: {
    DatePicker,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BButton,
    BOverlay,
    BTable,
    BCard,
    BRow,
    BCol,
    BPagination,
    AudioPlayer,
    BFormSelect
  },
  data() {
    return {
      playlist: [],
      itemPlay: {},
      titleId: '',
    }
  },
  setup() {
    const dateplay = ref(new Date())
    const refListTable = ref(null);
    const dataChannel = ref([])
    const channel_id = ref('')
    const perPage = ref(3);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 30, 50, 100];
    const searchQuery = ref('');
    const localSearchQuery = ref('');
    const loading = ref(true);
    const loading_schedule = ref(true)
    const dataItems = ref([]);
    const channel_name = ref('')
    const channelFirst = ref({})
    const stopPlay = ref(false)
    const tableColumns = [
      { key: 'Frame', sortable: false, label: 'Giờ phát sóng', thAttr: { width: '12%' } },
      { key: 'programFrames', sortable: false, label: 'Chương trình', },
    ];

    const fetchChannel = () => {
      store.dispatch('channel/fechData').then(response => {
        const result = response.data;

        loading.value = false
        if (result.code == 200) {
          const dataList = result.data;
          if (dataList.length) {
            dataChannel.value = dataList
            if (dataList[0]) {
              channelFirst.value = dataList[0]
              channel_id.value = dataList[0].id
              channel_name.value = dataList[0].name
              fetchSchedule()
            }
          }
        }
      })
    }
    fetchChannel()
    const fetchSchedule = () => {
      loading_schedule.value = true
      store.dispatch('schedule/show', {
        channel_id: channel_id.value,
        date_play: dateplay.value,
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
      })
        .then(response => {
          const result = response.data;
          loading_schedule.value = false
          if (result.code == 200) {
            dataItems.value = (result.data.data) ? result.data.data : []
            total.value = result.data.total
          }
        })
    }
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value
        ? refListTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });

    watch([perPage, dateplay, searchQuery], (val) => {
      currentPage.value = 1
      if (!loading_schedule.value) {
        fetchSchedule()
      }
    })
    watch([currentPage], (val) => {
      if (!loading_schedule.value) {
        stopPlay.value = true
        fetchSchedule()
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    })
    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value
    }

    const handleChannel = (channel) => {
      if (channel_id.value != channel.id) {
        channel_id.value = channel.id
        channel_name.value = channel.name
        loading_schedule.value = true
        currentPage.value = 1;
        dateplay.value = new Date()
        fetchSchedule()
      }
    }

    const onChangeSelect = (value) => {
      let item = dataChannel.value.filter((val) => {
        if (val.id == value) {
          return val;
        }
      })

      channel_id.value = value
      channel_name.value = item.name
      loading_schedule.value = true
      dateplay.value = new Date()
      fetchSchedule()

    }
    return {
      dateplay,
      dataChannel,
      dataItems,
      total,
      currentPage,
      perPage,
      updateSearchQuery,
      localSearchQuery,
      dataMeta,
      tableColumns,
      loading,
      loading_schedule,
      refListTable,
      channel_name,
      handleChannel,
      channel_id,
      onChangeSelect,
      stopPlay
    }
  },
  methods: {
    handUpdateItemAudio(type, title_id) {
      if (type == 'play') {
        this.stopPlay = !this.stopPlay
      } else {
        let current_index = this.playlist.map(function (obj) { return obj.titleId; }).indexOf(title_id);
        if (type == 'next') {
          current_index = current_index + 1;
        } else if (type == 'preview') {
          current_index = current_index - 1;
        }
        if (Object.keys(this.playlist[current_index]).length > 0) {
          this.itemPlay = this.playlist[current_index]
        } else {
          this.itemPlay = this.playlist[0]
        }
        this.titleId = this.itemPlay.titleId;
      }
    },
    onPlayItem(items, titleId) {
      let listItem = []
      items.forEach((val) => {
        if (val.urlPath != '') {
          listItem.push(val)
        }
        if (val.titleId == titleId) {
          this.itemPlay = val
          this.titleId = titleId
        }
      })
      if (listItem.length > 0) {
        this.playlist = listItem
      }
    },
    async onDownload(item) {

      let ext = item.urlPath.split('.').pop()
      const name = `${item.programName}.${ext}`;
      const url = item.urlPath;
      const data = await fetch(url);
      const blob = await data.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', objectUrl);
      link.setAttribute('download', name);
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
